import { FormType, HELP_CENTER_URL, PropertyTypes } from '@aloft/toolkit-shared';
import { Block, Flex, Link, Typography } from '@aloft/toolkit-sui';

import { ExportModalSelectFormType } from './ExportModalSelectFormType.tsx';

export const ExportModalTotalExport = ({
  formType,
  setFormType,
  propertyType = 'singleFamilyResidence',
  includeAnnotations,
  setIncludeAnnotations,
}: {
  formType: FormType;
  setFormType: (val: FormType) => void;
  includeAnnotations: boolean;
  setIncludeAnnotations: ((val: boolean) => void) | undefined;
  propertyType: PropertyTypes | undefined;
}) => (
  <Flex flexDirection="column">
    <Typography variant="h3">Export to Total</Typography>
    <Typography variant="body1">
      Exporting to TOTAL requires an active TOTAL subscription and&nbsp;
      <Link isExternal href="https://totalstore.alamode.com/product/aloft-appraiser-toolkit">
        the Appraisify Appraiser Toolkit report pack for TOTAL
      </Link>
      . Your export will include your adjustments, cost approach and workfile documentation.
      Currently, FNMA 1004, FNMA 1004C, FNMA 1025, FNMA 2055, and GP Residential are supported.
    </Typography>
    <Block height=".5rem" />
    <Typography variant="body1">
      <Link isExternal href={HELP_CENTER_URL}>
        Need help? Check out this article.
      </Link>
    </Typography>
    <ExportModalSelectFormType
      formType={formType}
      setFormType={setFormType}
      includeAnnotations={includeAnnotations}
      setIncludeAnnotations={setIncludeAnnotations}
      options={getFormOptions(propertyType)}
    />
  </Flex>
);

const getFormOptions = (propertyType: PropertyTypes): { value: FormType; label: string }[] => {
  switch (propertyType) {
    case 'singleFamilyResidence':
      return [
        { value: FormType.fnma1004, label: 'FNMA 1004' },
        { value: FormType.fnma2055, label: 'FNMA 2055' },
        { value: FormType.gpResidential, label: 'GP Residential' },
      ];
    case 'multiFamily':
      return [{ value: FormType.fnma1025, label: 'FNMA 1025' }];
    case 'manufacturedHome':
      return [{ value: FormType.fnma1004c, label: 'FNMA 1004C' }];
    default:
      throw new Error(`This property type (${propertyType}) is not yet supported.`);
  }
};
